export default __webpack_public_path__ + "media/images/logo_icon-8cab47075a4c3289bc38dd78c5bbd4cf.png";